import { CommissionMainContainer } from '@/modules/Commission';

const Commission = (): JSX.Element => <CommissionMainContainer />;

export default Commission;
